import { render, staticRenderFns } from "./AddressFrom.vue?vue&type=template&id=54bfe114&scoped=true&"
import script from "./AddressFrom.vue?vue&type=script&lang=js&"
export * from "./AddressFrom.vue?vue&type=script&lang=js&"
import style0 from "./AddressFrom.vue?vue&type=style&index=0&id=54bfe114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bfe114",
  null
  
)

export default component.exports